import Swiper, {
  Navigation,
  EffectFade,
} from 'swiper';
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'swiper/css';
import 'swiper/css/effect-fade';

document.addEventListener("DOMContentLoaded", () => {

  // mobile menu
  const masthead = document.querySelector('.masthead')

  document.querySelectorAll('.mobile-menu-toggle').forEach(el => {

    el.addEventListener('click', e => {
      e.preventDefault()

      masthead.classList.toggle('toggled')
    })
  })

  if (document.body.classList.contains('home')) {
    new Swiper('.swiper', {
      modules: [Navigation, EffectFade],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  } else if (document.body.classList.contains('page-template-template-gallery')) {
    document.querySelectorAll('.page-gallery--gallery-items').forEach(el => {

      const lightbox = new PhotoSwipeLightbox({
        gallery: el,
        children: 'a',
        pswpModule: () => import('photoswipe'),
      });

      lightbox.init();
    })
  }
})
